<template>
    <div class="main-cn">
        <div class="main-bd mg20" style="text-align: center;">
            <div style="margin: 10px 0">
                <el-button v-if="Acs('/home/approve')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="统计需要该账号审批的所有数据，从审批管理模块数据调取" placement="top">
                        <router-link :to="{ path: '/order/approve'}" target="_blank">
                            待我审批
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{checkCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/allocation')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="“全部线索”列表里未绑定业务员的线索总数" placement="top">
                        <router-link :to="{ path: '/sales-leads/allocation',query: {tab:'assign'}}" target="_blank">
                            待我分配
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{assignCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/my-clue')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="“我的线索”列表里的线索总数" placement="top">
                        <router-link :to="{ path: '/home/my-lead'}" target="_blank">
                            我的线索
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{myClueCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/reserve')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="“我的客户”列表填写了下次跟进的客户的数据总数" placement="top">
                        <router-link :to="{ path:  '/home/customer',query: {tab:'reserve'}}" target="_blank">
                            我的预约(近15天预约记录)
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{reserveCustomerCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/potential')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="我的客户“没有开通正式订单“的客户数据，例如只要开通了一个或以上正式订单的，就算成交客户，不管订单是否到期" placement="top">
                        <router-link :to="{ path: '/home/customer',query: {tab:'potential'}}" target="_blank">
                            待成交客户
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{potentialCustomerCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/wait-renew')" size="small" type="text">
                    <el-tooltip placement="right">
                        <div slot="content">
                            待续费客户：产品到期前30天内的都是快到期客户<br/><br/>
                            有多个产品的客户，只要有1个快到期就属于待续费客户。有的快到期，有的没到期，有的已到期，也算待续费客户
                        </div>
                        <router-link :to="{ path:  '/home/customer',query: {tab:'renew'}}" target="_blank">
                            待续费客户(产品未到期客户)
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{renewCustomerCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/not-renew')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="客户必须是所有产品都到期才能算到期客户" placement="top">
                        <router-link :to="{ path:  '/home/customer',query: {tab:'unrenew'}}" target="_blank">
                            未续费客户(产品已到期客户)
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{unrenewedCustomerCount}}</div>
                </el-button>
                <el-button v-if="Acs('/home/expire-order')" size="small" type="text">
                    <el-tooltip class="item" effect="dark" content="统计自己学校只能使用72小时的订单" placement="top">
                        <router-link :to="{ path:  '/home/expire-order',query: {tab:'expireOrder'}}" target="_blank">
                            产品使用72小时订单
                        </router-link>
                    </el-tooltip>
                    <div style="margin-top: 10px;color: #999999;font-size: 20px;">{{orderExpireCount}}</div>
                </el-button>
            </div>
        </div>
        <div class="home-draggable-modules">
        <div v-if="Acs('/home/approve')"
             class="home-draggable-module"
             :class="getModuleDragClass('approve')"
             :style="{order: getModuleOrder('approve')}"
             @dragstart="handleModuleDragStart($event, 'approve')"
             @dragover.prevent="handleModuleDragOver('approve')"
             @drop.prevent="handleModuleDrop($event, 'approve')"
             @dragend="handleModuleDragEnd">
        <div class="main-bd mg20">
            <div>
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/order/approve'}" target="_blank">
                        待我审批
                        <el-tooltip class="item" effect="dark" content="统计需要该账号审批的所有数据，从审批管理模块数据调取" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="size:18px;float: right"><router-link :to="{ path: '/order/approve'}" target="_blank"
                                                                      style="color: #409EFF">查看更多>></router-link></span>
                </h3>
                <el-table :data="checkData" @row-click="showDetail" :row-style="{cursor:'pointer'}">
                    <el-table-column prop="type_memo" label="审批类型"></el-table-column>
                    <el-table-column prop="desc" label="审批内容" width="350">
                        <template slot-scope="scope">
                            <span v-html="scope.row.desc"></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="proposer" label="申请人"></el-table-column>
                    <el-table-column prop="created_at" label="申请时间"></el-table-column>
                </el-table>
            </div>
        </div>
        </div>
        <div v-if="Acs('/home/allocation')"
             class="home-draggable-module"
             :class="getModuleDragClass('allocation')"
             :style="{order: getModuleOrder('allocation')}"
             @dragstart="handleModuleDragStart($event, 'allocation')"
             @dragover.prevent="handleModuleDragOver('allocation')"
             @drop.prevent="handleModuleDrop($event, 'allocation')"
             @dragend="handleModuleDragEnd">
        <clue :data="assignData">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/sales-leads/allocation',query: {tab:'assign'}}" target="_blank">
                        待我分配
                        <el-tooltip class="item" effect="dark" content="“全部线索”列表里未绑定业务员的线索总数" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="float: right"><router-link
                            :to="{ path: '/sales-leads/allocation',query: {tab:'assign'}}"
                            target="_blank"
                            style="color: #409EFF">查看更多>></router-link></span></h3>
            </template>
        </clue>
        </div>
        <div v-if="Acs('/home/my-clue')"
             class="home-draggable-module"
             :class="getModuleDragClass('myClue')"
             :style="{order: getModuleOrder('myClue')}"
             @dragstart="handleModuleDragStart($event, 'myClue')"
             @dragover.prevent="handleModuleDragOver('myClue')"
             @drop.prevent="handleModuleDrop($event, 'myClue')"
             @dragend="handleModuleDragEnd">
        <clue :data="myClue">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/sales-leads/my-index'}" target="_blank">
                        我的线索
                        <el-tooltip class="item" effect="dark" content="“我的线索”列表里的线索总数" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="float: right"><router-link :to="{ path: '/sales-leads/my-index'}" target="_blank" style="color: #409EFF">查看更多>></router-link></span>
                </h3>
            </template>
        </clue>
        </div>
        <div v-if="Acs('/home/reserve')"
             class="home-draggable-module"
             :class="getModuleDragClass('reserve')"
             :style="{order: getModuleOrder('reserve')}"
             @dragstart="handleModuleDragStart($event, 'reserve')"
             @dragover.prevent="handleModuleDragOver('reserve')"
             @drop.prevent="handleModuleDrop($event, 'reserve')"
             @dragend="handleModuleDragEnd">
        <customer :data="reserveCustomerData" type="reserve">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path:  '/home/customer',query: {tab:'reserve'}}" target="_blank">
                        我的预约记录
                        <el-tooltip class="item" effect="dark" content="“我的客户”列表填写了下次跟进的客户的数据总数" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="float: right">
                        <router-link :to="{ path:  '/home/customer',query: {tab:'reserve'}}" target="_blank" style="color: #409EFF">查看更多>></router-link>
                    </span>
                </h3>
            </template>
        </customer>
        </div>
        <div v-if="Acs('/home/potential')"
             class="home-draggable-module"
             :class="getModuleDragClass('potential')"
             :style="{order: getModuleOrder('potential')}"
             @dragstart="handleModuleDragStart($event, 'potential')"
             @dragover.prevent="handleModuleDragOver('potential')"
             @drop.prevent="handleModuleDrop($event, 'potential')"
             @dragend="handleModuleDragEnd">
        <customer :data="potentialCustomerData" type="potential">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/home/customer',query: {tab:'potential'}}" target="_blank">
                        我的待成交客户
                        <el-tooltip class="item" effect="dark" content="我的客户“没有开通正式订单“的客户数据，例如只要开通了一个或以上正式订单的，就算成交客户，不管订单是否到期" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="float: right"><router-link
                            :to="{ path: '/home/customer',query: {tab:'potential'}}" target="_blank"
                            style="color: #409EFF">查看更多>></router-link></span></h3>
            </template>
        </customer>
        </div>
        <div v-if="Acs('/home/wait-renew')"
             class="home-draggable-module"
             :class="getModuleDragClass('renew')"
             :style="{order: getModuleOrder('renew')}"
             @dragstart="handleModuleDragStart($event, 'renew')"
             @dragover.prevent="handleModuleDragOver('renew')"
             @drop.prevent="handleModuleDrop($event, 'renew')"
             @dragend="handleModuleDragEnd">
        <customer :data="renewCustomerData">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/home/customer',query: {tab:'renew'}}" target="_blank">
                        我的待续费客户
                        <el-tooltip placement="right">
                            <div slot="content">
                                待续费客户：产品到期前30天内的都是快到期客户<br/><br/>
                                有多个产品的客户，只要有1个快到期就属于待续费客户。有的快到期，有的没到期，有的已到期，也算待续费客户
                            </div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </router-link>
                    <span style="float: right"><router-link
                            :to="{ path: '/home/customer',query: {tab:'renew'}}" target="_blank"
                            style="color: #409EFF">查看更多>></router-link></span></h3>
            </template>
        </customer>
        </div>
        <div v-if="Acs('/home/not-renew')"
             class="home-draggable-module"
             :class="getModuleDragClass('unrenewed')"
             :style="{order: getModuleOrder('unrenewed')}"
             @dragstart="handleModuleDragStart($event, 'unrenewed')"
             @dragover.prevent="handleModuleDragOver('unrenewed')"
             @drop.prevent="handleModuleDrop($event, 'unrenewed')"
             @dragend="handleModuleDragEnd">
        <customer :data="unrenewedCustomerData">
            <template slot="table_head">
                <h3 class="home-drag-title" draggable="true">
                    <i class="el-icon-rank home-drag-handle" title="拖拽调整模块位置"></i>
                    <router-link :to="{ path: '/home/customer',query: {tab:'unrenew'}}" target="_blank">
                    我的到期客户
                    <el-tooltip class="item" effect="dark" content="客户必须是所有产品都到期才能算到期客户" placement="top">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                    </router-link>
                    <span style="float: right"><router-link :to="{ path: '/home/customer',query: {tab:'unrenew'}}" target="_blank" style="color: #409EFF">查看更多>></router-link></span>
                </h3>
            </template>
        </customer>
        </div>
        </div>
    </div>
</template>

<style>
    .item {
        margin-top: 10px;
        margin-right: 30px;
        margin-left: 25px;
    }
</style>
<script>
    import HomeService from "~/services/home";
    import OrderService from "~/services/order";
    import Clue from "~/views/home/tab/Clue.vue";
    import Customer from "~/views/home/tab/Customer.vue";
    import Business from "~/views/order/business.vue";

    const HOME_MODULES = ['approve', 'allocation', 'myClue', 'reserve', 'potential', 'renew', 'unrenewed'];

    export default {
        components: {
            Clue,
            Customer,
            Business
        },
        data() {
            return {
                checkData: [],
                checkCount: 0,
                assignData: [],
                assignCount: 0,
                myClue: [],
                myClueCount: 0,
                reserveCustomerData: [],
                reserveCustomerCount: 0,
                potentialCustomerData: [],
                potentialCustomerCount: 0,
                renewCustomerData: [],
                renewCustomerCount: 0,
                orderExpireCount:0,
                unrenewedCustomerData: [],
                unrenewedCustomerCount: 0,
                moduleOrder: HOME_MODULES.slice(),
                draggingModule: '',
                dragOverModule: '',
            }
        },
        created() {
            this.loadModuleOrder();
            this.getDoCheck();
            this.getDoAssign();
            this.getMyClue();
            this.getReserveCustomer();
            this.getPotentialCustomer();
            this.getRenewCustomer();
            this.getUnrenewCustomer();
            this.getExpireOrder();
        },
        methods: {
            getModuleStorageKey() {
                const userKey = this.$store.getters.userId || this.$store.getters.name || 'current-user';
                return 'home-module-order:' + userKey;
            },
            loadModuleOrder() {
                try {
                    const savedOrder = JSON.parse(localStorage.getItem(this.getModuleStorageKey()));
                    if (!Array.isArray(savedOrder)) {
                        return;
                    }

                    const validOrder = savedOrder.filter(module => HOME_MODULES.indexOf(module) !== -1);
                    HOME_MODULES.forEach((module, index) => {
                        if (validOrder.indexOf(module) === -1) {
                            validOrder.splice(index, 0, module);
                        }
                    });
                    this.moduleOrder = validOrder;
                } catch (e) {
                    this.moduleOrder = HOME_MODULES.slice();
                }
            },
            saveModuleOrder() {
                localStorage.setItem(this.getModuleStorageKey(), JSON.stringify(this.moduleOrder));
            },
            getModuleOrder(module) {
                return this.moduleOrder.indexOf(module);
            },
            getModuleDragClass(module) {
                return {
                    'is-dragging': this.draggingModule === module,
                    'is-drag-over': this.dragOverModule === module && this.draggingModule !== module,
                };
            },
            handleModuleDragStart(event, module) {
                const dragTitle = event.target.closest ? event.target.closest('.home-drag-title') : null;
                if (!dragTitle) {
                    return;
                }

                this.draggingModule = module;
                this.dragOverModule = '';
                if (event.dataTransfer) {
                    event.dataTransfer.effectAllowed = 'move';
                    event.dataTransfer.setData('text/plain', module);
                }
            },
            handleModuleDragOver(module) {
                if (this.draggingModule && this.draggingModule !== module) {
                    this.dragOverModule = module;
                }
            },
            handleModuleDrop(event, targetModule) {
                const draggingModule = this.draggingModule;
                if (!draggingModule || draggingModule === targetModule) {
                    this.handleModuleDragEnd();
                    return;
                }

                const nextOrder = this.moduleOrder.filter(module => module !== draggingModule);
                const targetIndex = nextOrder.indexOf(targetModule);
                const targetRect = event.currentTarget.getBoundingClientRect();
                const insertAfter = event.clientY > targetRect.top + targetRect.height / 2;
                nextOrder.splice(targetIndex + (insertAfter ? 1 : 0), 0, draggingModule);
                this.moduleOrder = nextOrder;
                this.saveModuleOrder();
                this.handleModuleDragEnd();
            },
            handleModuleDragEnd() {
                this.draggingModule = '';
                this.dragOverModule = '';
            },
            showDetail(data) {
                let path = "/order/view?id=" + data.order_id + "&flow_type=" + data.flow_type;
                path = path + '&type=' + data.type + '&revise_id=' + data.order_edit_id;
                let go_to = {
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                }
                OrderService.getDetail(data.order_id).then(res => {
                    let msg = ''
                    if (data.type != 2) { //关闭订单审批 无需考虑是否有撤销操作
                        if (data.flow_type == 1 && res.data['undo_product']) msg = '审核已撤销，无法进行审核操作'
                        if (data.flow_type == 2 && res.data['undo_finance']) msg = '审核已撤销，无法进行审核操作'
                        if (data.flow_type == 3 && res.data['undo_contract']) msg = '审核已撤销，无法进行审核操作'
                    }
                    if (msg) {
                        return this.$message({
                            type: 'error',
                            message: msg
                        });
                    }
                    this.$router.push(go_to);
                })
            },
            //待我审批
            getDoCheck() {
                HomeService.getList({type: 'DoCheck'}).then(res => {
                    this.checkData = res.data.list;
                    this.checkCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //待我分配
            getDoAssign() {
                HomeService.getList({type: 'DoAssign'}).then(res => {
                    this.assignData = res.data.list;
                    this.assignCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //我的线索
            getMyClue() {
                HomeService.getList({type: 'MyClue'}).then(res => {
                    this.myClue = res.data.list;
                    this.myClueCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //我的预约客户
            getReserveCustomer() {
                HomeService.getList({type: 'ReserveCustomer'}).then(res => {
                    this.reserveCustomerData = res.data.list;
                    this.reserveCustomerCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //我的待成交客户
            getPotentialCustomer() {
                HomeService.getList({type: 'PotentialCustomer'}).then(res => {
                    this.potentialCustomerData = res.data.list;
                    this.potentialCustomerCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //我的待续费客户
            getRenewCustomer() {
                HomeService.getList({type: 'RenewCustomer'}).then(res => {
                    this.renewCustomerData = res.data.list;
                    this.renewCustomerCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //我的未续费
            getUnrenewCustomer() {
                HomeService.getList({type: 'UnrenewedCustomer'}).then(res => {
                    this.unrenewedCustomerData = res.data.list;
                    this.unrenewedCustomerCount = res.data.count > 0 ? res.data.count : 0;
                });
            },
            //72小时订单
            getExpireOrder(){
                HomeService.getList({type: 'expireOrder'}).then(res => {
                    this.orderExpireCount = res.data > 0 ? res.data : 0;
                });
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .el-button + .el-button {
        margin-left: 48px;
    }
    .customer-name {
        cursor: pointer;
    }

    .customer-name:hover {
        color: #409EFF;
    }

    .home-draggable-modules {
        display: flex;
        flex-direction: column;
    }

    .home-draggable-module {
        transition: opacity 0.15s ease, background-color 0.15s ease;
    }

    .home-draggable-module.is-dragging {
        opacity: 0.45;
    }

    .home-draggable-module.is-drag-over {
        background-color: #ecf5ff;
    }

    .home-drag-handle {
        margin-right: 8px;
        color: #909399;
        font-size: 16px;
    }

    .home-drag-title {
        cursor: grab;
        user-select: none;
    }

    .home-drag-title:active {
        cursor: grabbing;
    }
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue